import { useEffect } from "react";
import { getNestedValue, setNestedValue } from "../../../utils/object";
import { IntelbrasAuthenticationTypeEnum, IntelbrasAuthenticationTypeText, IntelbrasTagRecordingEnum, IntelbrasTypeEnum, IntelbrasTypeText } from "../../../constants/readers-model";
import Input from "../../../components/Input/Input";
import Select from "../../../components/Select/Select";
import ToggleButton from "../../../components/ToggleButton/ToggleButton";

export function PartialFormIntelbras({ configuration, setConfiguration, setEditablePort, ...props }) {
   useEffect(() => {
      setEditablePort(true);
      if (!configuration) {
         setConfiguration({
            type: IntelbrasTypeEnum.FINGERPRINT,
            authenticationType: IntelbrasAuthenticationTypeEnum.FACIAL,
            tagRecording: IntelbrasTagRecordingEnum.PADRAO,
         });
      }
   }, []);

   function onChange(field, value) {
      const currentValue = getNestedValue(configuration, field);
      if (currentValue === value) return;
      setConfiguration(setNestedValue({ ...configuration }, field, value));
   }

   return (
      <div className="w-full grid grid-cols-2 gap-2.5">
         <Input
            name="user"
            id="user"
            labelText="Usuário"
            value={configuration?.user}
            onChange={({ target }) => onChange('user', target.value)}
            disabled={props.type === "consulta"}
            required={true}
         />
         <Input
            name="password"
            id="password"
            type="password"
            labelText="Senha"
            value={configuration?.password}
            onChange={({ target }) => onChange('password', target.value)}
            disabled={props.type === "consulta"}
            required={true}
         />
         <Select
            labelText="Tipo"
            value={configuration?.type}
            onChange={({ target }) => onChange('type', target.value)}
            disabled={props.type === "consulta"}
            required={true}
            options={[
               ...Object.entries(IntelbrasTypeEnum).map(([key, value]) => ({
                  value,
                  text: IntelbrasTypeText[value],
               }))
            ]}
         />
         <Select
            labelText="Gravação de Tag"
            value={configuration?.tagRecording}
            onChange={({ target }) => onChange('tagRecording', target.value)}
            disabled={props.type === "consulta"}
            required={true}
            options={[
               ...Object.entries(IntelbrasTagRecordingEnum).map(([key, value]) => ({
                  value,
                  text: value,
               }))
            ]}
         />
         {![IntelbrasTypeEnum.LPR, IntelbrasTypeEnum.UHF].includes(configuration?.type) && (
            <Select
               labelText="Tipo de Autenticação"
               value={configuration?.authenticationType}
               onChange={({ target }) => onChange('authenticationType', target.value)}
               disabled={props.type === "consulta"}
               required={true}
               options={[
                  ...Object.entries(IntelbrasAuthenticationTypeEnum).map(([key, value]) => ({
                     value,
                     text: IntelbrasAuthenticationTypeText[value],
                  }))
               ]}
            />
         )}
         <Input
            name="eventTimeout"
            id="eventTimeout"
            type="number"
            labelText="Timeout de Evento"
            tooltipVisible={true}
            tooltipText="Eventos registrados após esse tempo em segundos, serão ignorados. (0 = ignorar verificação)"
            value={configuration?.eventTimeout}
            onChange={({ target }) => onChange('eventTimeout', target.value)}
            disabled={props.type === "consulta"}
            required={true}
         />
         <div className="flex flex-col gap-1">
            {![IntelbrasTypeEnum.LPR, IntelbrasTypeEnum.UHF].includes(configuration?.type) && (
               <>
                  <ToggleButton
                     style={{ width: 'fit-content', paddingTop: '15px' }}
                     label={`Leitora com Validação de Máscara`}
                     onChange={(e) => onChange('userMaskValidation', e.target.checked)}
                     selected={configuration?.userMaskValidation}
                  />
                  <ToggleButton
                     style={{ width: 'fit-content', paddingTop: '15px' }}
                     label={`Ignora fabricante digital`}
                     onChange={(e) => onChange('ignoreDigitalManufacturer', e.target.checked)}
                     selected={configuration?.ignoreDigitalManufacturer}
                  />
                  <ToggleButton
                     style={{ width: 'fit-content', paddingTop: '15px' }}
                     label={`Modo Online`}
                     onChange={(e) => onChange('modoOnline', e.target.checked)}
                     selected={configuration?.modoOnline}
                  />
                  <ToggleButton
                     style={{ width: 'fit-content', paddingTop: '15px' }}
                     label={`Habilita Cartão Reverso`}
                     onChange={(e) => onChange('reverseCardEnabled', e.target.checked)}
                     selected={configuration?.reverseCardEnabled}
                  />
               </>
            )}
            <ToggleButton
               style={{ width: 'fit-content', paddingTop: '15px' }}
               label={`Habilita NTP na Leitora`}
               onChange={(e) => onChange('ntpEnabled', e.target.checked)}
               selected={configuration?.ntpEnabled}
            />
         </div>
         {![IntelbrasTypeEnum.LPR, IntelbrasTypeEnum.UHF].includes(configuration?.type) && (
            <div className="flex flex-col gap-1">
               <ToggleButton
                  style={{ width: 'fit-content', paddingTop: '15px' }}
                  label={`Leitor Termográfico`}
                  onChange={(e) => onChange('thermographicReader', e.target.checked)}
                  selected={configuration?.thermographicReader}
               />
               <ToggleButton
                  style={{ width: 'fit-content', paddingTop: '15px' }}
                  label={`Habilita Controle de Temperatura`}
                  onChange={(e) => onChange('temperatureControlEnabled', e.target.checked)}
                  selected={configuration?.temperatureControlEnabled}
               />
               {configuration?.temperatureControlEnabled && (
                  <div className="grid grid-cols-2 gap-3 mt-3.5!">
                     <Input
                        name="maxTemperature"
                        id="maxTemperature"
                        type="number"
                        labelText="Limite Temperatura Alta (C)"
                        value={configuration?.maxTemperature}
                        onChange={({ target }) => onChange('maxTemperature', target.value)}
                        disabled={props.type === "consulta"}
                        required={true}
                     />
                     <Input
                        name="minTemperature"
                        id="minTemperature"
                        type="number"
                        labelText="Limite Temperatura Baixa (C)"
                        value={configuration?.minTemperature}
                        onChange={({ target }) => onChange('minTemperature', target.value)}
                        disabled={props.type === "consulta"}
                        required={true}
                     />
                  </div>
               )}
            </div>
         )}
      </div>
   );
}